import React, { Component } from "react";
import BsyTableList from "../BsyTableList";
import './index.css';

export default class BsyMemberSyncLog extends Component {


    constructor(props) {
        super(props);
        this.state = {
 
            hasCount: true,
            limit: 20,
            skip: 0,
            logs: {
                has_qr_modify: false,
                users: [],
                count: 0,
                not_joined: 0,
            },
        }
    }
    componentDidMount() {
        this.get_member_sync_log_list();
    }

    get_member_sync_log_list = () => {
        const { limit, skip, status } = this.state
        //FX.STATIC.user_corps.mode
        React.axios(`/${window.FX.STATIC.user_corps.mode}/list_syslog`, {
            limit: limit,
            status: status,
            skip: skip * limit
        }).then(res => {

            const logs = {
                ...{
                    users: res.data.list,
                    count: res.data.count,
                }
            }

            this.setState({
                logs: logs
            })

        }).catch(res => {

        })
    }
 
    skipChange = (val) => {
        this.setState({ skip: val }, () => {
            this.get_member_sync_log_list()
        })
    }

    listLimitChange = (val) => {
        this.setState({ limit: val }, () => {
            this.get_member_sync_log_list()
        })
    }

    listFilterChange = (val) => {
        this.setState({ filter: val }, () => {
            this.get_member_sync_log_list()
        })
    }


    render() {
        const { limit, skip, logs } = this.state;
        const list = [
            {
                width: 205,
                key: "create_time",
                value: React.language("operating.time")
            },
            {
                width: 250,
                key: "event_type",
                value: React.language("type.operation"),
            },
            {
                width: 200,
                key: "new",
                value: React.language("dingding.auto.syn.log.edit.before"),
            },
            {
                width: 200,
                key: "old",
                value: React.language("dingding.auto.syn.log.edit.after"),
            }
        ]

        return <div className='approve-pane' >

            <BsyTableList
                getValue={this.getTableValue}
                limit={limit}
                skip={skip}
                skipChange={this.skipChange}
                listLimitChange={this.listLimitChange}
                listFilterChange={this.listFilterChange}
                styleType={window.mode}
                userCont={logs}
                count={logs.count}
                hasTurnPage={!!logs.count}
                list={list}
                multiple={false}
                noDarg={true}
                noMenu={true}
            />

        </div>
    }
}